import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from "react-router-dom";
import { post } from '../../utils/api';
import { Form, FormLine, FormItem, FormInput } from '../common/Form';
import useApiGet from '../../hooks/useApiGet';
//
// Компонент для создания счетчика мероприятия
//
const CounterAdd = () => {
	const { t, i18n } = useTranslation();
    const { id } = useParams();
    const lang = i18n.language;
	const method = '/events/' + id;
	const navigate = useNavigate();
	const [ startDate, setStartDate ] = useState('');
	const [ startValue, setStartValue ] = useState('');
	const [ stopDate, setStopDate ] = useState('');
	const [ stopValue, setStopValue ] = useState('');
    const [ isSaving, setIsSaving ] = useState(false);
    const [ saveError, setSaveError ] = useState('');
	const [ data ] = useApiGet({ method });
    const [ event, setEvent ] = useState(null);

	useEffect(() => {
		if(data) {
			setEvent(data.event);
		}
	}, [ data ]);

    // Отправка данных
	const onSubmit = async () => {
        setIsSaving(true);
        setSaveError('');

        const data = {
            start_date: startDate,
            start_value: parseInt(startValue),
            stop_date: stopDate,
            stop_value: parseInt(stopValue),
        };

        const result = await post(`/counters/${event._id}`, data);

        if(result.error) {
            setSaveError(result.error);
        } else {
			navigate('/cabinet/eventview/' + result.data.event._id + '/action/updated');
        }
        setIsSaving(false);
	};

    return (
		<div>
	    	<h1>{event ? t('counter.title_for')+event.name[lang] : t('counter.title')}</h1>
			{(isSaving || !event) ? <span>{t('common.loading')}</span> :
			<Form
                error={saveError}
                wide={true}
                submit={t('common.add')}
                onSubmit={onSubmit}
            >
                {/* Даты */}
				<FormLine>
                    <FormItem>
                        <FormInput
                            id='startDate'
                            type='text'
                            value={startDate}
                            onChange={setStartDate}
                            placeholder='YYYY-MM-DD'
                            label={t('counter.start_date')}
                            required={true}
                        />
                    </FormItem>
                    <FormItem>
                        <FormInput
                            id='stopDate'
                            type='text'
                            value={stopDate}
                            onChange={setStopDate}
                            placeholder='YYYY-MM-DD'
                            label={t('counter.stop_date')}
                            required={true}
                        />
                    </FormItem>
                </FormLine>
                {/* Значения */}
				<FormLine>
                    <FormItem>
                        <FormInput
                            id='startValue'
                            type='text'
                            value={startValue}
                            onChange={setStartValue}
                            label={t('counter.start_value')}
                            required={true}
                        />
                    </FormItem>
                    <FormItem>
                        <FormInput
                            id='stopValue'
                            type='text'
                            value={stopValue}
                            onChange={setStopValue}
                            label={t('counter.stop_value')}
                            required={true}
                        />
                    </FormItem>
                </FormLine>
			</Form>}
		</div>
	);
};

export default CounterAdd;
